import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d9c36b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row justify-content-start" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Create Shift")
  ])
], -1))
const _hoisted_4 = { class: "col-5 mt-4" }
const _hoisted_5 = { class: "form-floating" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Allow Rider", -1))
const _hoisted_7 = { class: "form-floating" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Shift Fee", -1))
const _hoisted_9 = { class: "form-floating" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Start Time", -1))
const _hoisted_11 = { class: "form-floating" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "End Time", -1))
const _hoisted_13 = { class: "form-floating" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "shift date", -1))
const _hoisted_15 = { class: "form-floating" }
const _hoisted_16 = ["value"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "City", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "w-100 btn btn-lg btn-primary",
  type: "submit"
}, "Submit", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("form", {
          onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.allow_rider) = $event)),
              class: "form-control",
              placeholder: "Allow Riders",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.form.allow_rider]
            ]),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.shift_fee) = $event)),
              class: "form-control",
              placeholder: "Full Name",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.form.shift_fee]
            ]),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.start_time) = $event)),
              class: "form-control",
              placeholder: "start time",
              type: "time"
            }, null, 512), [
              [_vModelText, $setup.form.start_time]
            ]),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("input", {
              type: "time",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.end_time) = $event)),
              class: "form-control",
              placeholder: "end_time",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.form.end_time]
            ]),
            _hoisted_12
          ]),
          _createElementVNode("div", _hoisted_13, [
            _withDirectives(_createElementVNode("input", {
              type: "date",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.shift_date) = $event)),
              class: "form-control",
              placeholder: "shift_date",
              required: ""
            }, null, 512), [
              [_vModelText, $setup.form.shift_date]
            ]),
            _hoisted_14
          ]),
          _createElementVNode("div", _hoisted_15, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.city) = $event)),
              class: "form-control",
              required: ""
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.cities, (city) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: city.id,
                  value: city.id
                }, _toDisplayString(city.name), 9, _hoisted_16))
              }), 128))
            ], 512), [
              [_vModelSelect, $setup.form.city]
            ]),
            _hoisted_17
          ]),
          _hoisted_18
        ], 32)
      ])
    ])
  ]))
}